// @flow
import { isCD } from "../rest/utils/envDetection";

const formatUrl = url => {
    if (isCD) {
        const slashIndex = url.lastIndexOf("/");
        if (slashIndex >= 0) {
            return `./DCIM/100JEALO/${url.substring(slashIndex + 1)}`;
        }
        return `./DCIM/100JEALO/${url}`;
    }
    return url;
};

const getOriginal = thumb => {
    let r = thumb.replace("/146/", "/800/");
    // let r = thumb.replace(/.*\/146\//, "https://cdn.getjealous.com/photos/");
    r = r.replace("http://", "https://");
    r = r.replace(".mp4", ".jpg");
    return formatUrl(r);
};

const getOriginalFromId = (user, filename) =>
    formatUrl(`https://cdn.getjealous.com/photos/${user.photoDir}/${filename}`);

const getSquare = thumb => {
    let r = thumb.replace("/146/", "/100s/");
    r = r.replace("http://", "https://");
    r = r.replace(".mp4", ".jpg");
    return formatUrl(r);
};

const getThumb = thumb => {
    let r = thumb.replace("/100s/", "/300/");
    r = r.replace("/146/", "/300/");
    r = r.replace("http://", "https://");
    r = r.replace(".mp4", ".jpg");
    return formatUrl(r);
};

export { getOriginal, getOriginalFromId, getSquare, getThumb };



// WEBPACK FOOTER //
// ./src/utils/image.js